export default __webpack_public_path__ + "static/media/pembelian-barang.87c81de8.png";